import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface OnlyCtaModel extends BaseModel {
  variables?: { [key: string]: string } | OnlyCtaVariables;
}

export interface OnlyCtaVariables {
  OnlyCtaLink: string;
  OnlyCtaText: string;
  OnlyCtaLinkSegmentRegex: string;
}

export class OnlyCtaInitVariables implements OnlyCtaVariables {
  OnlyCtaLink = '';
  OnlyCtaText = '';
  OnlyCtaLinkSegmentRegex = '';
}

export class OnlyCtaInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new OnlyCtaInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
